<template>
  <div v-if="bank_payment_info" class="bank_payment_info">
    <div class="bank_payment_info__left">
      <div class="bank_payment_info__left__wrap" ref="content">
        <div class="main_info" ref="main_info">
          <div class="line row">
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="bank_payment_info.date" type="text" :label="translate('bank_payment.date')"
                        :placeholder="translate('bank_payment.date')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <router-link :to="'/client/' + bank_payment_info.client_id" class="link">
                <fg-input v-model="bank_payment_info.client_name" type="text" :label="translate('bank_payment.client_name')"
                          :placeholder="translate('bank_payment.client_name')" :readonly="true" />
              </router-link>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="sum_in_rub" type="text" :label="translate('bank_payment.sum')"
                        :placeholder="translate('bank_payment.sum')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="date_created" type="text" :label="translate('bank_payment.ts_create')"
                        :placeholder="translate('bank_payment.ts_create')" :readonly="true" />
            </div>
          </div>

          <div class="line row">
            <div class="col-md-4 col-sm-4">
              <fg-input v-model="bank_payment_info.inn" type="text" :label="translate('bank_payment.inn')"
                        :placeholder="translate('bank_payment.inn')" :readonly="true"/>
            </div>
            <div class="col-md-8 col-sm-8">
              <fg-input v-model="bank_payment_info.ur_name" type="text" :label="translate('bank_payment.ur_name')"
                        :placeholder="translate('bank_payment.ur_name')" :readonly="true"/>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-12 col-sm-12 text_wrap">
              <div class="form-group">
                <label>{{ translate('bank_payment.description') }}</label>
                <textarea class="input_text" name="comment" v-model="bank_payment_info.descr" rows="5" :readonly="true"/>
              </div>
            </div>
          </div>
        </div>

        <div class="line text-center buttons" v-if="$store.getters.getPermissions.permissionGod === true">
          <span
              v-if="bank_payment_info.status === 0"
              class="btn btn-success btn-fill btn-wd"
              @click.prevent="edit_bank_payment(1)"
          >
            {{ translate('bank_payment.take_on_work') }}
          </span>

          <span
              v-if="bank_payment_info.status === 1"
              class="btn btn-success btn-fill btn-wd"
              @click.prevent="edit_bank_payment(2)"
          >
            {{ translate('bank_payment.complete_success') }}
          </span>

          <span
              v-if="bank_payment_info.status === 1"
              class="btn btn-success btn-fill btn-wd"
              @click.prevent="edit_bank_payment(4)"
          >
            {{ translate('bank_payment.close_with_error') }}
          </span>
        </div>
      </div>

    </div>

<!--    <div class="bank_payment_info__right">-->
<!--      <Summary type="bank_payment" :info="bank_payment_info" :view_history="false" />-->
<!--    </div>-->
  </div>

</template>
<script>
import Summary from "components/UIComponents/Summary/Summary.vue";

export default {
  name: 'BankPaymentInfo',
  components: {
    Summary
  },

  props: {
    bank_payment: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      bank_payment_info: {},
    }
  },

  created() {
    this.bank_payment_info = JSON.parse(JSON.stringify(this.bank_payment))
  },

  activated() {
    this.bank_payment_info = JSON.parse(JSON.stringify(this.bank_payment))
  },

  computed: {
    date_created(){
      return this.get_date(this.bank_payment_info.ts_create)
    },
    sum_in_rub(){
      return this.bank_payment_info.sum / 100
    },
  },

  watch: {
    bank_payment(){
      this.bank_payment_info = {...this.bank_payment}
    }
  },

  methods: {
    edit_bank_payment(status) {
      this.$http.v1.updateStatusClientRequest(this.bank_payment_info.id, {status}, (response) => {
        this.global_notify('info', this.translate('bank_payment.saved_success'))
        this.bank_payment_info = response.data
        this.$emit('update')
      })
    },
  }
}

</script>

<style lang='scss' scoped>
.bank_payment_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    .form_select{
      .form-control {
        width: 100%;
      }
    }

    .response_table {
      height: auto;
      padding: 10px 0 0;

      .status {
        width: 5%;
      }

      table {
        tbody {
          .online {
            color: #15ab00;
          }

          span.badge {
            font-size: 12px;
          }

          span {
            font-size: 20px;
          }
          .simcard_item{
            color: #66615b;
            &:hover{
              tr{
                background-color: #eee;
              }
            }
          }
        }

        td {
          padding: 5px;
        }
        .remove{
          width: 60px;
          //display: flex;
          //align-items: center;
          //justify-content: center;
          .mdi{
            vertical-align: middle;

          }
          .mdi-check{
            &:hover{
              color: darkgreen;
            }
          }
          .mdi-close{
            &:hover{
              color: darkred;
            }
          }

        }
      }
      .w70{
        width: 70px;
      }
      .w30{
        width: 30px;
      }

      .new_simcard {
        cursor: pointer;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 10px;
        padding: 10px;
        background: #41b8831f;
        border: 1px dashed #41b883;
        transition: 0.2s;
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
        .mdi {
          font-size: 20px;
        }
        span{
          font-size: 14px;
        }
        &__block{
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }
        &:hover {
          background: #41b8835e;
        }
      }
    }

    .buttons {
      margin-top: 10px;
      .btn{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
